// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"group-text__visuallyhidden--Iot9g","focusable":"group-text__focusable--Jra2r","text":"group-text__text--j_HcT"};